module.exports = "<a class=\"dropdown-item waves-light \" mdbRippleRadius href=\"# \">{{game.name}}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/game-link/game-link.component.html
// module id = ./src/app/components/game-link/game-link.component.html
// module chunks = main